import { render, staticRenderFns } from "./BuscarDocumentos.vue?vue&type=template&id=6e354624&scoped=true"
import script from "./BuscarDocumentos.vue?vue&type=script&lang=js"
export * from "./BuscarDocumentos.vue?vue&type=script&lang=js"
import style0 from "./BuscarDocumentos.vue?vue&type=style&index=0&id=6e354624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e354624",
  null
  
)

export default component.exports